import { useCallback, useMemo } from 'react'
import { generateAllForPayload } from 'utils/helpers'
import { useDownloadMutation } from 'services'

export const useFileDownload = type => {
    const [download, result] = useDownloadMutation()

    const handleDownload = useCallback(
        ({ extraOptions, ...data }) => {
            const payload = generateAllForPayload({ type, ...data })
            download({ ...payload, ...extraOptions })
        },
        [download]
    )

    return useMemo(
        () => ({
            download: handleDownload,
            result,
        }),
        [handleDownload]
    )
}
